export const tickerItems = [
  "【抢先版】某头部电商平台季度内部复盘流出，重点披露大促数据口径调整细节",
  "内部信源确认：新能源补贴新政或在三月落地，涉及厂商名单抢先预览",
  "三线以上艺人与经纪公司解约潮背后，被删档的薪酬条款原稿浮出水面",
  "独家线报：某国民级App灰度测试内购新分层，价目表抢先速递",
  "匿名投稿通道收到17份同源文件，指向某地产商明股实债新结构",
  "财经内幕：两家城商行合并草案里的不良剥离条款被提前外泄",
  "科技抢先：旗舰芯片良率测试数据遭内部上传，参数待全面核验",
];

export const navItems = [
  { label: "独家头条", href: "#headline" },
  { label: "热度沸点", href: "#heat" },
  { label: "抢先速递", href: "#express" },
  { label: "专题合集", href: "#special" },
  { label: "内部信源", href: "#insider" },
];

export const channelTabs = [
  { id: "hot", label: "24h热度沸点" },
  { id: "inner", label: "内部线人优先" },
  { id: "verify", label: "已核验线索" },
  { id: "brew", label: "正在发酵" },
];

export const heatBoard = [
  {
    id: 1,
    tag: "商业谍报",
    title: "百亿级并购案幕后对赌条款泄露，股价异动前三天已有内幕价码",
    heat: 982,
    delta: "+68",
    verified: true,
    src: "3名核心线人",
  },
  {
    id: 2,
    tag: "影视内幕",
    title: "顶流IP续集换角内幕：导演删除的试镜视频与违约金原话",
    heat: 874,
    delta: "+41",
    verified: false,
    src: "匿名投稿",
  },
  {
    id: 3,
    tag: "职场实录",
    title: "某大厂裁员名单分级表流出，从「优化」到「预留再战」共五档",
    heat: 793,
    delta: "+27",
    verified: true,
    src: "内部员工",
  },
  {
    id: 4,
    tag: "科技抢先",
    title: "折叠屏新形态工程机真机照现身，铰链方案与量产时间点全曝光",
    heat: 661,
    delta: "+19",
    verified: false,
    src: "供应链线报",
  },
  {
    id: 5,
    tag: "财经曝光",
    title: "明星基金经理重仓挪移记录被翻出，申报日期前后存在时间差",
    heat: 540,
    delta: "+12",
    verified: true,
    src: "2名独立信源",
  },
];

export const expressFeed = [
  {
    id: "e01",
    mark: "首爆",
    tag: "互联网 · 抢先版",
    title: "共享出行平台整改新规草案外泄：司机抽成上限或降至12%",
    summary: "内部信源提供的最新一版监管沟通纪要显示，平台方被要求就抽成结构作出阶梯式让步，部分城市先行试点。文件标注「不予公开」，落款为本周一。",
    time: "12 分钟前",
    source: "平台内部 · 已交叉验证",
    reads: "86.4w",
    comments: 1240,
    cover: "https://readdy.ai/api/search-image?query=editorial%20tech%20news%20cover%20showing%20modern%20ride%20sharing%20app%20on%20phone%20amid%20regulatory%20documents%20and%20city%20skyline%2C%20moody%20crimson%20and%20warm%20amber%20tones%2C%20cinematic%20high%20contrast%2C%20gritty%20journalistic%20photojournalism&width=760&height=520&seq=feed-net-01&orientation=landscape",
  },
  {
    id: "e02",
    mark: "独家",
    tag: "娱乐圈 · 第一手",
    title: "选秀厂牌现金流断裂，主办方被曝拖欠三城场馆尾款",
    summary: "多方信源指向某头部厂牌旗下年度巡演资金链吃紧，供应商开始集中催款。核心联络人透露，内部正讨论缩减两站并紧急引入新资方。",
    time: "38 分钟前",
    source: "供应商信源",
    reads: "61.2w",
    comments: 893,
    cover: "https://readdy.ai/api/search-image?query=dimly%20lit%20concert%20backstage%20with%20empty%20stadium%20seats%2C%20stacked%20moving%20equipment%20and%20spreadsheets%2C%20cinematic%20amber%20and%20deep%20red%20mood%2C%20investigative%20photojournalism%20cover&width=760&height=520&seq=feed-enter-02&orientation=landscape",
  },
  {
    id: "e03",
    mark: "线报",
    tag: "商业 · 内幕深度",
    title: "新消费品牌「纸面融资」连环拆解：签约金额与到账差额达六成",
    summary: "匿名投稿整理的多份银行回单与补充协议，揭示多起明星新消费项目宣传融资额与真实到账的差距。首篇已获法务线索复核。",
    time: "1 小时前",
    source: "匿名投稿 × 审计信源",
    reads: "45.8w",
    comments: 662,
    cover: "https://readdy.ai/api/search-image?query=modern%20consumer%20brand%20packaging%20boxes%20with%20financial%20documents%20contracts%20and%20seal%2C%20warm%20amber%20lighting%20crimson%20accents%2C%20editorial%20finance%20expose%20photojournalism&width=760&height=520&seq=feed-biz-03&orientation=landscape",
  },
  {
    id: "e04",
    mark: "抢先",
    tag: "科技 · 抢先版",
    title: "年度开发者大会未公布环节被拆解：AI 助手将深度嵌入原生生态",
    summary: "供应链与内测用户双向信源交叉，勾勒出本次大会隐藏发布的主线逻辑。具体功能仍在最后核验阶段，暂不公布原始截图。",
    time: "2 小时前",
    source: "双源交叉 · 待全量核验",
    reads: "39.1w",
    comments: 458,
    cover: "https://readdy.ai/api/search-image?query=futuristic%20developer%20keynote%20stage%20with%20large%20screen%20abstract%20ai%20neural%20visuals%2C%20dark%20warm%20tone%20with%20amber%20and%20red%20glow%2C%20cinematic%20tech%20reveal%20photojournalism&width=760&height=520&seq=feed-ai-04&orientation=landscape",
  },
  {
    id: "e05",
    mark: "曝料",
    tag: "地产 · 深度调查",
    title: "三线文旅大盘「以房抵债」实锤：供应商被引导签署回购豁免书",
    summary: "调查组收到的一手文书显示，项目方以未竣工房源冲抵工程款，并要求签保密与放弃追偿条款。涉事金额跨数亿规模。",
    time: "3 小时前",
    source: "一手文书",
    reads: "31.6w",
    comments: 512,
    cover: "https://readdy.ai/api/search-image?query=aerial%20view%20of%20unfinished%20real%20estate%20buildings%20with%20crane%20at%20dusk%2C%20warm%20amber%20sky%20crimson%20tones%2C%20documentary%20investigation%20photojournalism%2C%20high%20contrast&width=760&height=520&seq=feed-property-05&orientation=landscape",
  },
  {
    id: "e06",
    mark: "内幕",
    tag: "金融 · 第一手",
    title: "量化团队「抢跑」质疑发酵，监管窗口期与调仓时间戳被逐一对照",
    summary: "举报材料中整理的同日高频调仓记录，正在被独立法务顾问逐条比对。事件仍在持续核验，多名当事人已进入沟通流程。",
    time: "4 小时前",
    source: "举报材料",
    reads: "27.9w",
    comments: 389,
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20stock%20trading%20charts%20on%20monitors%20with%20algorithms%20and%20timestamps%2C%20dark%20warm%20amber%20red%20palette%2C%20financial%20investigation%20cinematic%20photojournalism&width=760&height=520&seq=feed-fin-06&orientation=landscape",
  },
];

export const rankExtra = [
  { rank: 6, title: "某连锁餐饮后厨卫生「合格证」涉嫌批量造假，多店样本曝光", heat: 488, delta: "+9" },
  { rank: 7, title: "顶流主播「坑位费+保底」合同被拆，实际带货GMV口径存疑", heat: 421, delta: "+15" },
  { rank: 8, title: "海外留学院校「保录」链条浮出，中介与招生办邮件被公开", heat: 377, delta: "+7" },
];

export const topics = [
  {
    title: "互联网裁员现形记",
    lead: "从优化话术到真实名单，那些被删档的分级标准",
    count: 28,
    read: "412.6w",
    cover: "https://readdy.ai/api/search-image?query=empty%20modern%20office%20cubicles%20at%20night%20with%20papers%20and%20moved%20boxes%2C%20moody%20crimson%20and%20warm%20amber%20cinematic%20lighting%2C%20editorial%20investigative%20cover%2C%20vertical&width=640&height=760&seq=topic-ai-01&orientation=portrait",
  },
  {
    title: "娱乐圈解约风暴",
    lead: "被删档的合同、违约金与消失在通稿里的名字",
    count: 34,
    read: "388.1w",
    cover: "https://readdy.ai/api/search-image?query=backstage%20red%20curtain%20with%20scattered%20contract%20pages%20and%20stage%20lights%2C%20dramatic%20crimson%20amber%20warm%20tones%2C%20gossip%20expose%20editorial%20cover%2C%20vertical&width=640&height=760&seq=topic-star-02&orientation=portrait",
  },
  {
    title: "咖啡新战事内幕",
    lead: "补贴战背后的成本、加盟与供应链账本",
    count: 19,
    read: "256.3w",
    cover: "https://readdy.ai/api/search-image?query=stacked%20coffee%20cups%20and%20beans%20on%20wooden%20bar%20with%20finance%20documents%20and%20steam%2C%20warm%20amber%20crimson%20editorial%20investigation%20cover%2C%20vertical&width=640&height=760&seq=topic-coffee-03&orientation=portrait",
  },
  {
    title: "医美暴利内幕",
    lead: "一针利润十倍，从原料到话术的完整拆解",
    count: 41,
    read: "301.9w",
    cover: "https://readdy.ai/api/search-image?query=elegant%20clinic%20interior%20with%20vials%20and%20injection%20tools%20under%20dramatic%20warm%20lighting%2C%20crimson%20amber%20tones%2C%20investigative%20beauty%20industry%20editorial%20cover%2C%20vertical&width=640&height=760&seq=topic-beauty-04&orientation=portrait",
  },
  {
    title: "学区房暗盘记",
    lead: "房价、户籍与灰色中介链条里的一手房源",
    count: 22,
    read: "198.4w",
    cover: "https://readdy.ai/api/search-image?query=residential%20neighborhood%20with%20for%20sale%20signs%20and%20blueprint%20documents%2C%20warm%20evening%20amber%20crimson%20tone%2C%20documentary%20real%20estate%20investigation%20cover%2C%20vertical&width=640&height=760&seq=topic-house-05&orientation=portrait",
  },
  {
    title: "玄学与商学院",
    lead: "割韭菜的课程里，情绪价值如何被定价",
    count: 15,
    read: "143.2w",
    cover: "https://readdy.ai/api/search-image?query=minimal%20stage%20with%20coins%20candles%20and%20notebook%20on%20warm%20desk%2C%20mystic%20crimson%20amber%20dramatic%20light%2C%20editorial%20expose%20cover%2C%20vertical&width=640&height=760&seq=topic-tao-06&orientation=portrait",
  },
];

export const insiderNotes = [
  {
    level: "A · 内部纪要",
    who: "供应链管理岗 · 从业 9 年",
    title: "关于新品良率与首发备货的真实口径",
    brief: "对外宣称良率稳定，内部 QA 群其实已在调整备货与召回预案。具体数据我保留了原始截图，可进一步核验。",
    time: "确认 08:40",
  },
  {
    level: "B · 一手文件",
    who: "法务协作岗 · 从业 6 年",
    title: "总部下发的「口径统一」通知原文",
    brief: "针对上季度客诉的处理指引被逐条列出，部分话术与公示口径存在明显出入，我有盖章版本。",
    time: "确认 07:15",
  },
  {
    level: "A · 资深线人",
    who: "区域运营负责人",
    title: "下季度渠道策略调整的内部风向",
    brief: "区域会在本月内试点新的分成模型，签约门店名单已在内部流转，建议盯紧「试点」与「强制」两个词。",
    time: "确认 06:02",
  },
];

export const verifySteps = [
  {
    step: "01",
    title: "线索分级",
    desc: "投稿按文档、截图、视频等载体先行分级，确认信息密度。",
  },
  {
    step: "02",
    title: "双源交叉",
    desc: "不满足于单一信源，重大线索至少两位独立信源交叉印证。",
  },
  {
    step: "03",
    title: "匿名保护",
    desc: "去身份化处理全部路径，投稿人信息不与稿件内容同库存储。",
  },
];

export const footChannels = [
  { label: "独家头条", href: "#headline" },
  { label: "热度沸点", href: "#heat" },
  { label: "抢先速递", href: "#express" },
  { label: "专题合集", href: "#special" },
  { label: "内部信源", href: "#insider" },
];

export const footAbout = [
  "关于 98爆料",
  "投稿与核验机制",
  "线索保护承诺",
  "内容合作",
];

export const heroMain = {
  kicker: "今日 · 抢鲜头条",
  title: "百亿并购对赌细节外泄",
  subtitle: "独家信源坐实：公告发布前 72 小时，多路资金已完成价码对冲。匿名投稿提供的条款原稿，正在独立法务逐条复核。",
  meta: "爆点评级 S · 双信源已交叉 · 复核中",
  heat: "98.2w",
  reads: "已追踪 3.1w 条讨论",
  cover: "https://readdy.ai/api/search-image?query=dark%20city%20skyline%20at%20night%20overlaid%20with%20merger%20documents%20stock%20graphs%20and%20seal%2C%20dramatic%20crimson%20red%20and%20warm%20amber%20lighting%2C%20cinematic%20high%20contrast%20investigative%20business%20news%20hero%20background%2C%20editorial%20photojournalism&width=1920&height=1080&seq=hero-bank-01&orientation=landscape",
};